<header id="ic-header">
  <div id="ic-logo-group">
    <ic-icon-svg iconName="navigation" class="hamburger" (click)="onToggleMenu()"></ic-icon-svg>
    <span id="ic-logo" (click)="onLogoClick()"> <img src="assets/svg/icentral_logo.svg"> </span>
  </div>

  @if (user()?.isToroUser()) {
    <div id="ic-account-group">
      <ic-toolbar-admin-account placement="header"></ic-toolbar-admin-account>
    </div>
  } @else {
    <div id="ic-account-group" class="ic-account-group--customer">
      <ic-toolbar-account-select [user]="user()" placement="header"></ic-toolbar-account-select>
    </div>
  }

  <div id="ic-weather-alerts-container" #weatherAlerts [class.ic-weather-alerts-container--weather-too-wide]="weatherTooWide()">
    <div id="ic-weather-group" #weatherGroup>
      <ic-toolbar-weather [zipCode]="account()?.zip ?? ''" [locationPending]="weatherLocationPending()"></ic-toolbar-weather>
    </div>
    <div id="ic-alerts-group">
      <ic-toolbar-alerts [accountId]="account()?.accountID ?? ''"></ic-toolbar-alerts>
    </div>
  </div>

  <div id="ic-user-group">
    <ic-toolbar-user></ic-toolbar-user>
  </div>

  <div id="ic-profile-img">
    <img ngSrc="assets/img/avatars/sunny.png" width="50" height="50" alt="John Doe" (click)="menu.toggle($event)"/>
    <p-menu #menu [model]="items" popup="true"></p-menu>
  </div>

</header>
